import { Trans } from '@lingui/macro'
import classnames from 'classnames'
import Link from 'next/link'
import React, { FC } from 'react'

import { BlogItem } from '../../interfaces'
import { ForwardArrow } from '../icons'
import styles from './ChannelBlog.module.css'

interface Props {
  item: BlogItem
  className?: string
}

const BlogComponent: FC<Props> = ({ item, className }: Props) => {
  const relativeLink = `/blogs/${item.url}`
  return (
    <div key={item.id} className={classnames(styles.articleWrapper, className)}>
      <Link href={relativeLink}>
        <a className={styles.link}>
          <div>
            <img alt={item.title} className={styles.articleImage} src={item.imageUrl} />
          </div>
          <div className={styles.titleButtonWrapper}>
            <div className={styles.articleTitle}>{item.title}</div>
            <div className={styles.articleReadButtonWrapper}>
              <span className={styles.articleReadButton}>
                <span className={styles.read}>
                  <Trans>READ</Trans>
                </span>
                <ForwardArrow className={styles.forwardArrowIcon} />
              </span>
            </div>
          </div>
        </a>
      </Link>
    </div>
  )
}

export default BlogComponent
